<template>
    <a-config-provider :locale="locale">
        <router-view/>
    </a-config-provider>
</template>

<script>
import {LoadingOutlined} from '@ant-design/icons-vue';
import {h} from 'vue';
import {Spin, message} from "ant-design-vue";
import { i18nManager } from "@/i18n/i18n";

//设置全局加载样式
Spin.setDefaultIndicator({
    indicator: h(LoadingOutlined, {
        style: {
            fontSize: '24px',
            margin: '-12px 0 0 -12px'
        },
        spin: true,
    }),
});

//提示信息全局设置
message.config({
    getContainer: () => document.getElementById('app')
});

export default {
    name: 'App',
    components: {},
    setup() {
        return {
            locale: i18nManager.antdLocale,
        }
    },
}
</script>

<style>
#app {
    height: 100%;
    width: 100%;
    overflow: hidden;
}

.ant-modal .ant-modal-content {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    background-color: var(--carousel-bg);
    -webkit-transition: background-color 300ms;
    -moz-transition: background-color 300ms;
    -ms-transition: background-color 300ms;
    -o-transition: background-color 300ms;
    transition: background-color 300ms;
}

.ant-modal .ant-modal-header {
    -webkit-border-radius: 8px 8px 0 0;
    -moz-border-radius: 8px 8px 0 0;
    border-radius: 8px 8px 0 0;
    padding: 30px;
    border-bottom: none;
    background-color: var(--carousel-bg);
    -webkit-transition: background-color 300ms;
    -moz-transition: background-color 300ms;
    -ms-transition: background-color 300ms;
    -o-transition: background-color 300ms;
    transition: background-color 300ms;
}

.ant-modal .ant-modal-title {
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    color: var(--primary-title-text);
    -webkit-transition: color 300ms;
    -moz-transition: color 300ms;
    -ms-transition: color 300ms;
    -o-transition: color 300ms;
    transition: color 300ms;
}

.ant-modal .ant-modal-close {
    width: 56px;
    height: 88px;
    right: 10px;
}

.ant-modal .ant-modal-close svg path {
    fill: var(--primary-content-text);
}

.ant-modal .ant-modal-close:hover svg path {
    fill: var(--primary-title-text);
}

.ant-modal .ant-modal-body {
    padding: 0 30px;
    color: var(--primary-content-text);
    -webkit-transition: color 300ms;
    -moz-transition: color 300ms;
    -ms-transition: color 300ms;
    -o-transition: color 300ms;
    transition: color 300ms;
}

.ant-modal-confirm .ant-modal-body {
    padding: 30px 30px 24px 30px;
}

.ant-modal .ant-modal-footer {
    -webkit-border-radius: 0 0 8px 8px;
    -moz-border-radius: 0 0 8px 8px;
    border-radius: 0 0 8px 8px;
    padding: 30px 30px 24px 30px;
    border-top: none;
}

.ant-spin svg path {
    fill: var(--spin-active);
}

.ant-message .ant-message-notice-content {
    color: var(--primary-title-text);
    background-color: var(--carousel-bg);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
}

.ant-btn[disabled], .ant-btn[disabled]:hover {
    opacity: 0.7;
    pointer-events: none;
}

.ant-modal-confirm-btns .ant-btn {
    -webkit-transition: all 300ms;
    -moz-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    transition: all 300ms;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    color: var(--primary-active-btn);
    border-color: var(--primary-active-btn);
    background: var(--login-card-bg);
}

.ant-modal-confirm-btns .ant-btn:hover {
    color: var(--primary-active-btn-hover);
    border-color: var(--primary-active-btn-hover);
    background: var(--login-card-bg);
}

.ant-modal-confirm-btns .ant-btn-dangerous {
    color: #ffffff;
    background: #ff411c;
    border-color: #ff411c;
}

.ant-modal-confirm-btns .ant-btn-dangerous:hover {
    color: #ffffff;
    background: #da3819;
    border-color: #da3819;
}

.ant-modal-confirm-btns .ant-btn-primary {
    color: var(--reverse-text);
    border-color: var(--primary-active-btn);
    background: var(--primary-active-btn);
}

.ant-modal-confirm-btns .ant-btn-primary:hover {
    color: var(--reverse-text);
    border-color: var(--primary-active-btn-hover);
    background: var(--primary-active-btn-hover);
}

.ant-notification .ant-notification-notice {
    color: var(--primary-content-text);
    background: var(--login-card-bg);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    -webkit-transition: all 300ms;
    -moz-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    transition: all 300ms;
}

.ant-notification .ant-notification-notice-message {
    color: var(--primary-title-text);
    -webkit-transition: all 300ms;
    -moz-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    transition: all 300ms;
}

.ant-notification svg[data-icon="close"] path {
    fill: var(--primary-title-text);
}
</style>
